export default function getResource(label, vars = []) {
    const resources = {
        appliesToAll: `S’applique à ${vars[0]}, sélectionnez tous les choix qui s’appliquent :`,
        appliesToOne: `S’applique à ${vars[0]}, sélectionnez un choix :`,
        selectOne: 'Sélectionner une option :',
        selectAll: 'Sélectionner toutes les options qui s’appliquent :',
        saveAndContinue: 'Enregistrer et continuer',
        and: ' et ',
        skipThisQuestion: 'Ignorer cette question',
        searchIngredients: 'Rechercher ingrédients',
        searchBrands: 'Rechercher les marques',
        viewIngredientList: 'Afficher la liste des ingrédients',
        viewAllBrands: 'Voir toutes les marques',
        skincareIngredientPreferences: 'Préférences d’ingrédients de soins pour la peau',
        hairIngredientPreferences: 'Préférences d’ingrédients pour les cheveux',
        makeupIngredientPreferences: 'Préférences d’ingrédients pour le maquillage',
        fragranceIngredientPreferences: 'Préférences d’ingrédients pour le parfum',
        favoriteBrands: 'Marques favorites',
        noPreference: 'Aucune préférence',
        selectAllThatApply: 'Sélectionner toutes les options qui s’appliquent',
        clear: 'Tout réinitialiser',
        apply: 'Appliquer',
        noResults: 'Aucun résultat trouvé. Essayez',
        clearSearch: 'd’effacer votre recherche',
        useOur: 'Utilisez notre ',
        shadeFinder: 'Explorateur de teinte',
        toDiscover: '  pour découvrir plus de correspondances en fonction de votre fond de teint actuel, ou rendez-vous dans un magasin Sephora et demandez un balayage du ton de la peau Color IQ.',
        colorIQModalTitle: 'Couleur Qi',
        colorIQModalDescription: 'Couleur Qi est un système exclusif qui utilise une technologie avancée pour vous aider à trouver la teinte parfaite parmi tous les fonds de teint.',
        colorIQLink: 'Magasinez les correspondances de fond de teint',
        gotIt: 'Compris',
        viewAll: 'Voir tout',
        colorIQHistoryTitle: 'Vos valeurs Color IQ enregistrées',
        latest: 'ACTUEL',
        captured: 'Capturé',
        joinBeautyInsiderToSave: 'Inscrivez-vous au programme Beauty Insider pour économiser',
        signInToSave: 'Ouvrir une session pour économiser'
    };
    return resources[label];
}
